import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("meta", {
  name: "apple-mobile-web-app-capable",
  content: "yes"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("My Dashboard")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: "https://cdn.discordapp.com/attachments/327423555899883528/941380935528644708/unknown.png" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("My Dashboard")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("strong", null, "Stretching and Therapy", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.discordapp.com/attachments/327423555899883528/941631695134814208/Fitz_Sitting_Floor_Stretching.png",
  alt: "Vector_IMG"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Exercising and Fitness", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.discordapp.com/attachments/327423555899883528/941631696116285440/Fitz_Standing.png",
  alt: "Vector_IMG"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Goals and Progress", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.discordapp.com/attachments/327423555899883528/941631695893983262/Isometric_Stickers_Target.png",
  alt: "Vector_IMG"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Online Chat", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.discordapp.com/attachments/327423555899883528/941631695684255764/Lifesavers_Bust.png",
  alt: "Vector_IMG"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "Fun and Games", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.discordapp.com/attachments/327423555899883528/941631695436800021/Fitz_Standing1.png",
  alt: "Vector_IMG"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "Acknowledgements", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Copyright 2022 ~ A SCAD StartUp Creation")
], -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Vortex is a web application created by Reflex. Members of Reflex in alphabetical order include, but are not limited to: ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Carly ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Colin ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Greg ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Jacob ")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Ryan ")
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_ion_avatar, {
                slot: "end",
                a: "",
                href: "/MyAccount"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            a: "",
            href: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_thumbnail, { slot: "end" }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            a: "",
            href: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_thumbnail, { slot: "end" }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            a: "",
            href: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_thumbnail, { slot: "end" }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            a: "",
            href: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_thumbnail, { slot: "end" }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            a: "",
            href: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_thumbnail, { slot: "end" }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            a: "",
            href: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_subtitle, null, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23,
                  _hoisted_24,
                  _hoisted_25,
                  _hoisted_26,
                  _hoisted_27,
                  _hoisted_28
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}